export function getThreeDotsMenu(items, layout, isEnabled) {
  return items.filter(item => {
    return (
      item.id !== 'ANALYZE' ||
      (item.id === 'ANALYZE' && layout === 'xRayCephalometric' && isEnabled)
    )
  })
}
